import { redeemCodeApi } from '../util/api_calls/ProjectApiCalls';

/**
 * CodeUnlockActions
 * Mirrors the exact pattern from AuthActions throughout this project.
 */

const redeemCode = (parameters, dispatch) => {

    redeemCodeApi(
        parameters,
        payload => {
            dispatch(redeemCodeFinish(payload));
        },
        error => {
            dispatch(redeemCodeError(error));
        }
    );

    return {
        type: 'REDEEM_CODE_START',
        payload: parameters,
    };
};

const redeemCodeFinish = payload => ({
    type: 'REDEEM_CODE_FINISH',
    payload: { ...payload },
});

const redeemCodeError = error => {
    console.error('redeemCode error', error);
    let payload = {};
    if (error && error.constructor && error.constructor.name === 'Error') {
        payload = { message: 'There was an error, please contact support.' };
    } else {
        payload = { ...(error || {}) };
    }
    return {
        type: 'REDEEM_CODE_ERROR',
        payload,
    };
};

const resetCodeUnlock = () => ({
    type: 'REDEEM_CODE_RESET',
    payload: {},
});

export { redeemCode, resetCodeUnlock };
